export const CARD_TITLE = "Top Sites by Performance";

export const TABLE_COLUMNS = [
  { key: "name", label: "Site" },
  { key: "chargers", label: "Chargers" },
  { key: "sessions", label: "Sessions" },
  { key: "energy", label: "Energy (kWh)" },
  { key: "utilizationTime", label: "Utilization Time" },
  { key: "utilization", label: "Utilization" },
];

export const MOCK_TOP_SITES = [
  { name: "HQ-North", chargers: 24, sessions: 312, energy: 1240.5, utilization: 82 },
  { name: "Depot-East", chargers: 18, sessions: 245, energy: 980.2, utilization: 76 },
  { name: "Park-West", chargers: 32, sessions: 198, energy: 760.8, utilization: 58 },
  { name: "HQ-South", chargers: 20, sessions: 267, energy: 1050.3, utilization: 71 },
  { name: "Station-Central", chargers: 34, sessions: 221, energy: 795.7, utilization: 63 },
];
